/** Notifications sahifasi lug'ati (ru). */
export default {
  title: "Уведомления",
  total_one: "всего {{count}}",
  total_few: "всего {{count}}",
  total_many: "всего {{count}}",
  total_other: "всего {{count}}",
  markAll: "Отметить все как прочитанные",
  marked_one: "{{count}} отмечено как прочитанное",
  marked_few: "{{count}} отмечены как прочитанные",
  marked_many: "{{count}} отмечены как прочитанные",
  marked_other: "{{count}} отмечены как прочитанные",
  nothingToMark: "Нечего отмечать",
  markFailed: "Не удалось отметить как прочитанные",
  unread: "Непрочитанные",
  loadFailed: "Не удалось загрузить уведомления.",
  caughtUp: "Всё прочитано",
  none: "Уведомлений пока нет",
  desc: "Здесь появятся согласования, передачи и напоминания.",
  pagination: "уведомлений",
};
